<template lang="pug">
  v-dialog(
    :value="true"
    v-bind="dialogProps"
    @click:outside="$modals.close()"
  )
    v-card(v-bind="DIALOG_TYPES_DATA[type].cardAttrs").pa-4
      v-list-item(v-if="title")
        v-list-item-content
          h4.text-h6: strong {{ title }}
        v-list-item-action
          v-btn(
            fab
            text
            @click.stop="$modals.close()"
          ): v-icon mdi-close
      v-card-text.mt-4.subtitle-1(v-bind="DIALOG_TYPES_DATA[type].cardTextAttrs")
        .mb-5(
          v-html="message"
        )
        api-form(
          v-model="model"
          :method="method"
          :fields="fields"
          :btn-props="{ btnText: acceptBtnText, class: 'ml-auto' }"
          :success-callback="(resp) => success(resp.data.data)"
        )
          template(#preppend-actions)
            v-spacer
            v-btn.px-4.mr-4(
              text
              rounded
              @click="decline"
            ) {{ cancelBtnText }}
</template>

<script>
import { DIALOG_TYPES_DATA } from '../constants';

export default {
  props: {
    title: { type: String, default: 'Подтвердите действие' },
    message: { type: String, default: '' },
    icon: { type: String, default: null },
    componentInitialData: { type: [Object, String, Array, Number], default: null },

    dialogProps: {
      type: Object,
      default: () => ({
        width: 560,
      }),
    },

    method: { type: Function, default: null },
    fields: { type: Array, required: true },
    successCallback: { type: Function, default: () => {} },

    acceptBtnText: { type: String, default: 'Подтвердить' },
    cancelBtnText: { type: String, default: 'Отмена' },

    type: { type: String, default: 'info' },
  },
  data() {
    return {
      model: {},
      dialog: false,
      DIALOG_TYPES_DATA,
    };
  },
  methods: {
    decline() {
      this.$modals.close();
    },
    success(data) {
      this.successCallback(data);
      this.$modals.close();
    },
  },
};
</script>
